import {getMenuList} from '@/libs/util'

import routerList from '@/router/router'
import ysDatas from '@/libs/ys-data'

export default {
  state: {
    indexSwiperRightBtn: false,
    windowWidth: 0,
    windowHeight: 0,
    navStyle: {
      bg: false, // 背景颜色
      shadow: false, // false为没有弥散阴影
      img: false, // false 白色LOGO
      Fixed: true, // false 为不浮动
      title: true,
      menuColor: true, // 导航颜色
      menu: false // false为三横模式
    }
  },
  getters: {
    muenList: () => getMenuList(routerList),
    ysData: () => ysDatas
  },
  mutations: {
    getIndexSwiperRightBtn: (state, status) => {
      state.indexSwiperRightBtn = status
    },
    getWindowWidth: (state, px) => {
      state.windowWidth = px
    },
    getWindowHeight: (state, px) => {
      state.windowHeight = px
    },
    putProductMenuStatus: (state, status) => {
      state.productMenuStatus = status
    },
    putNavStyle: (state, type) => {
      if (state.windowWidth <= 750) { // 移动端
        switch (type) {
          case 'one':
            state.navStyle = {
              bg: false, // 背景颜色
              shadow: false, // false为没有弥散阴影
              img: false, // false 白色LOGO
              Fixed: true, // false 为不浮动
              title: false,
              menuColor: true, // 导航颜色
              menu: false // false为三横模式
            }
            break
          default:
            state.navStyle = {
              bg: true, // 背景颜色
              shadow: true, // false为没有弥散阴影
              img: true, // false 白色LOGO
              Fixed: true, // false 为不浮动
              title: false,
              menuColor: true, // 导航颜色
              menu: false // false为三横模式
            }
        }
      } else { // pc端
        switch (type) {
          case 'one': // 首屏白色Logo白色字三横
            state.navStyle = {
              bg: false, // 背景颜色
              shadow: false, // false为没有弥散阴影
              img: false, // false 白色LOGO
              Fixed: true, // false 为不浮动
              title: true,
              menuColor: true, // 导航颜色
              menu: false // false为三横模式
            }
            break
          case 'homeScene':
            state.navStyle = {
              bg: false, // 背景颜色
              shadow: false, // false为没有弥散阴影
              img: true, // false 白色LOGO
              Fixed: true, // false 为不浮动
              title: false,
              menuColor: false, // 导航颜色
              menu: true // false为三横模式
            }
            break
          default:
            state.navStyle = {
              bg: true, // 背景颜色
              shadow: true, // false为没有弥散阴影
              img: true, // false 白色LOGO
              Fixed: true, // false 为不浮动
              title: false,
              menuColor: false, // 导航颜色
              menu: true // false为三横模式
            }
        }
      }
    }
  },
  actions: {}
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js